import { render, staticRenderFns } from "./VehicleContractComments.vue?vue&type=template&id=5cfc4ecb&scoped=true"
import script from "./VehicleContractComments.vue?vue&type=script&lang=ts"
export * from "./VehicleContractComments.vue?vue&type=script&lang=ts"
import style0 from "./VehicleContractComments.vue?vue&type=style&index=0&id=5cfc4ecb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfc4ecb",
  null
  
)

export default component.exports